import { notify } from 'components/ToastNotification/ToastNotification';
import { IconManager } from 'components/_universal/IconManager/IconManager';
import { ToastTypes } from 'types/CommonTypes';
import {
    CopyIconWrapper,
    EditableSectionWrapper,
    EditIconWrapper,
    SectionTitle,
} from './EditableSection.styled';

interface IProps {
    title: string;
    children: React.ReactNode;
    isEditing: boolean;
    toggleEditing: () => void;
    onCopy?: () => string;
}

export const EditableSection = ({
    title,
    children,
    isEditing,
    toggleEditing,
    onCopy,
}: IProps) => {
    const handleCopy = async () => {
        if (!onCopy) return;
        const text = onCopy().trim();
        if (!text) {
            notify('Brak treści do skopiowania')[ToastTypes.WARNING]();
            return;
        }
        try {
            await navigator.clipboard.writeText(text);
            notify('Skopiowano do schowka')[ToastTypes.SUCCESS]();
        } catch {
            notify('Nie udało się skopiować')[ToastTypes.ERROR]();
        }
    };

    return (
        <>
            <SectionTitle>{title}</SectionTitle>
            <EditableSectionWrapper isEditing={isEditing}>
                {onCopy && (
                    <CopyIconWrapper onClick={handleCopy}>
                        <IconManager name={'CopyIcon'} cursorPointer />
                    </CopyIconWrapper>
                )}
                <EditIconWrapper onClick={toggleEditing}>
                    <IconManager
                        name={isEditing ? 'EditBlueFormIcon' : 'EditFormIcon'}
                        cursorPointer
                    />
                </EditIconWrapper>
                {children}
            </EditableSectionWrapper>
        </>
    );
};
